/* eslint-disable max-len */
import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardHeader, CCardBody,
  CBreadcrumb, CBreadcrumbItem, CButton
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { updateCompositionRequestAction } from '../../store/composition/compositionActions';
import CompositionInputs from '../../components/CompositionInputs/CompositionInputs';
import { useTranslation } from '../../hooks/useTranslation';

const UpdateComposition = ({ updateCompositionRequest, isLoading, updateCompositionData, compositionList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();

  const fromList = compositionList?.find(item => item.CompositionId?.toString() === id);
  const compositionData = location.state?.composition || fromList || null;

  const handleSubmit = (data) => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const sessionUserId = localStorage.getItem('sessionUserId');
    const userId = sessionUserId || userData?.sessionUserId;

    if (userId && userId !== 'undefined') {
      updateCompositionRequest({ data: { ...data, compositionId: id, SessionUserId: String(userId) }, navigate });
    } else {
      console.error('User session not found');
    }
  };

  const handleCancel = () => {
    navigate('/composition');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/composition" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('compositions')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateComposition')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateComposition')}</h4>
              {compositionData?.CompositionId && (
                <small className="text-muted">{t('id')}: {compositionData.CompositionId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {compositionData ? (
                <CompositionInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateCompositionData}
                  initialData={compositionData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center">
                  <p>{t('noDataFound')}</p>
                  <CButton color="primary" onClick={handleCancel}>
                    {t('backToCompositionList')}
                  </CButton>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateCompositionData: state.compositionReducer.updateCompositionData,
  compositionList: state.compositionReducer.compositionList,
});

const mapDispatchToProps = (dispatch) => ({
  updateCompositionRequest: (payload) => dispatch(updateCompositionRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateComposition);
